/**
 * Download document text stored in Firestore (content / fullText).
 */
export function downloadDocumentFile(doc) {
    if (!doc) return;

    const text =
        (doc.fullText && String(doc.fullText).trim()) ||
        (doc.content && String(doc.content).trim()) ||
        '';

    if (!text) {
        window.alert('No downloadable content for this document.');
        return;
    }

    const baseName = (doc.name || doc.fileName || 'document').replace(/[/\\?%*:|"<>]/g, '-');
    const ext = guessExtension(doc, text);
    const filename = baseName.includes('.') ? baseName : `${baseName}${ext}`;

    const mime = doc.type && doc.type.includes('/') ? doc.type : 'text/plain;charset=utf-8';
    const blob = new Blob([text], { type: mime });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}

function guessExtension(doc, text) {
    const name = (doc.name || '').toLowerCase();
    if (name.endsWith('.pdf')) return '';
    if (name.endsWith('.txt')) return '';
    if (name.endsWith('.md')) return '';
    if (name.endsWith('.csv')) return '';
    if (doc.type?.includes('pdf')) return '.txt';
    if (text.startsWith('{') || text.startsWith('[')) return '.json';
    return '.txt';
}
